import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './AskDoctor.css';
// Add useNavigate hook
const SERVER_URL = process.env.REACT_APP_TEST_API_URL;

const AskDoctor = () => {

// Add useNavigate hook
const navigate = useNavigate();
// State for users and form
const [questions, setQuestions] = useState([]);
const [searchTerm, setSearchTerm] = useState('');

  // Load initial data (simulated)
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try{
      const response = await fetch(`${SERVER_URL}/api/doctor/allQuestions`);
      const result = await response.json();
      setQuestions(result);
    }   
    catch(error) {
      console.error('There was a problem with the fetch operation:', error);
    };
  };

  // Delete user
  const deleteQuestion = async(id) => {
    console.log(id)
    if (window.confirm('Are you sure you want to delete this question?')) {
      await fetch(`${SERVER_URL}/api/doctor/deleteQuestion/${id}`);
      setQuestions(questions.filter(question => question._id !== id));
      fetchData()
    }
  };


  // Add handleUserClick function
   const handleUserClick = (userId) => {
        if (userId) {
        navigate(`/user/${userId}`);
        }
   };

   // answer Question
   const answerQuestion = (qId) => {
        if (qId) {
        navigate(`/question/${qId}`);
        }
    };

  // Filter questions based on search term
  const filteredQuestions = questions.filter(question => 
    question.concern.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
 
    <div className="user-management">
      
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search concern..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
              
      <div className="users-table-container">
        <h3>Questions List</h3>
        {questions.length > 0 ? (
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Concern</th>
                <th>Question</th>
                <th>Image Url</th>
                <th>Date</th>
                <th>User Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredQuestions.map((question,index) => (
                <tr key={question._id}>
                  <td>{index+1}</td>
                  <td>{question.concern}</td>
                  <td>{question.question}</td>
                  <td>
                    {question.imageUrl ? (
                    <img 
                    src={SERVER_URL+'/'+question.imageUrl} 
                    alt="Preview" 
                    style={{ 
                      maxWidth: '100px', 
                      maxHeight: '100px', 
                      marginLeft: '10px' 
                    }} 
                  />
                    ) : (
                    <span>No image Provided</span>
                    )}
                  </td>
                  <td>{new Date(question.createdAt).toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: '2-digit'})}</td>
                  <td>
                    {question.userId ? (
                    <span 
                        className="user-name-link" 
                        onClick={() => handleUserClick(question.userId._id)}
                    >
                        {question.userId.name || 'N/A'}
                    </span>
                    ) : 'N/A'}
                  </td>
                  <td>
                { question.status === "pending" ? (
                    <span className="status-badge status-cancelled">Pending</span>
                ) : question.status === "answered" ? (
                    <span className="status-badge status-complete">Answered</span>
                ) : (
                    <span className="status-badge">{question.status}</span>
                )}
                </td>
                  <td className="actions-cell">
                    <button
                      className="btn-edit"
                      onClick={() => answerQuestion(question._id)}
                    >
                      Answer
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => deleteQuestion(question._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-users">No Questions found.</p>
        )}
      </div>
    </div>
        
  );
};

export default AskDoctor;